import { Button, Stack, useTheme } from "@mui/material";
import { CheckCheck } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { MarkAllReadButtonProps } from "web_myplann/NotificationCenter/Types/MarkAllReadButtonProps";

export const MarkAllReadV2Button: FC<MarkAllReadButtonProps> = ({
	onClick,
	disabled = false,
}) => {
	const { t } = useResource();
	const { iconSize, spacingTokens } = useTheme();

	return (
		<Stack alignItems="flex-end" px={spacingTokens.lg} py={spacingTokens.xs}>
			<Button
				variant="textLink"
				size="small"
				onClick={onClick}
				disabled={disabled}
				data-testid="notification-center-mark-all-read"
			>
				<CheckCheck aria-hidden size={iconSize.xs} />
				{t(Resources.Notifications.readAll)}
			</Button>
		</Stack>
	);
};
